import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ReusoAutomaticoComponent } from './reuso-automatico.component';
import { AuthGuardService } from '../../shared/filters/auth-guard.service';
import { ListaVendasComponent } from './lista-vendas/lista-vendas.component';
import { CadastrarVendasComponent } from './cadastrar-vendas/cadastrar-vendas.component';
import { ListarReusoCadastradoComponent } from './listar-reuso-cadastrado/listar-reuso-cadastrado.component';
import { ListarReusoVinculadoComponent } from './listar-reuso-vinculado/listar-reuso-vinculado.component';
import { ExtratoReusoAutomaticoComponent } from './extrato-reuso-automatico/extrato-reuso-automatico.component';

const routes: Routes = [{
  path: '',
  component: ReusoAutomaticoComponent,
  children: [
  {
      path: 'lista-vendas',
      component: ListaVendasComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['LISTAR_REUSOS_CADASTRADOS'] }
    },
      {
      path: 'cadastrar-vendas',
      component: CadastrarVendasComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['CADASTRAR_VENDAS'] }
    },
    {
      path: 'listar-reuso-cadastrado',
      component: ListarReusoCadastradoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['LISTAR_REUSOS_CADASTRADOS'] }
    },
    {
      path: 'listar-reuso-vinculado',
      component: ListarReusoVinculadoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['LISTAR_REUSOS_VINCULADOS'] }
    },
    {
      path: 'extrato-reuso-automatico',
      component: ExtratoReusoAutomaticoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['EXTRATO_REUSO_AUTOMATICO'] }
    },
  ],

}];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
})
export class ReusoAutomaticoRoutingModule { }

export const routedComponents = [
  ReusoAutomaticoComponent, 
  ListaVendasComponent,
  CadastrarVendasComponent,
  ListarReusoCadastradoComponent,
  ListarReusoVinculadoComponent,
  ExtratoReusoAutomaticoComponent,
];
